import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import DraggableBox from "../DraggableBox";
import useBackgroundProps from "../../../hooks/draggables/useBackgroundProps";
const DraggableContainer = ({ item: { id, props, children }, elementId, ...rest }) => {
    const { props: backgroundImageProps, style: backgroundImageStyle } = useBackgroundProps(props?.backgroundImage);
    return (_jsx("div", { className: classNames(props?.className || "mx-auto max-w-7xl bg-white px-6 py-16 lg:px-8", !props?.text && !children?.length
            ? "flex items-center justify-center"
            : ""), ...backgroundImageProps, style: {
            ...backgroundImageStyle,
        }, "editor-key": id, "editor-has-childs": (children?.length > 0).toString(), ...rest, children: _jsx(DraggableBox, { elementId: elementId, childs: children, itemProps: props, itemId: id }) }));
};
export default DraggableContainer;
//# sourceMappingURL=DraggableContainer.js.map